import React from "react";
import { mix } from "polished";
import { Skeleton } from "@material-ui/lab";
import {
  Box,
  BoxProps,
  Breadcrumbs as MUIBreadcrumbs,
  styled,
  Typography,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { BreadcrumbItem, useBreadcrumbs } from ".";
import { PRIMARY_BLUE } from "../../theme";
import { AccountCrumbChip } from "./components/AccountCrumbChip";

export interface CrumbChipProps extends BoxProps {
  to?: string;
}

export const ChipHoverColor = mix(
  0.04,
  PRIMARY_BLUE["700"],
  PRIMARY_BLUE["50"],
);
export const ChipFocusColor = mix(
  0.12,
  PRIMARY_BLUE["700"],
  PRIMARY_BLUE["50"],
);

const CrumbChip = styled((props) => {
  const { to, ...other } = props;
  const component = to ? Link : "span";
  return <Box component={component} to={to} {...other} />;
})(({ theme, to }) => ({
  display: "inline-block",
  textDecoration: "none",
  borderRadius: 4,
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  color: to ? theme.palette.primary.main : theme.palette.text.primary,
  backgroundColor: to ? PRIMARY_BLUE["50"] : theme.palette.grey["50"],
  "&:hover": {
    backgroundColor: to ? ChipHoverColor : theme.palette.grey["50"],
  },
  "&:focus": {
    backgroundColor: to ? ChipFocusColor : theme.palette.grey["50"],
    outline: "none",
  },
})) as React.FC<CrumbChipProps>;

export const DefaultCrumb: React.FC<BreadcrumbItem> = ({ id, to, label }) => {
  return (
    <CrumbChip key={id} to={to} data-testid="Breadcrumbs__Crumb">
      <Typography variant="body2" component="span">
        {label}
      </Typography>
    </CrumbChip>
  );
};

export const Breadcrumbs: React.FC = () => {
  const crumbs = useBreadcrumbs();

  return crumbs.length ? (
    <MUIBreadcrumbs data-testid="Breadcrumbs">
      {crumbs.map((c) => {
        return c.label ? (
          <Box key={c.id}>
            {c.type === "Account" ? (
              <AccountCrumbChip {...c} />
            ) : (
              <DefaultCrumb {...c} />
            )}
          </Box>
        ) : (
          <Skeleton
            data-testid="Breadcrumb__Crumb--loading"
            key={c.id}
            variant="rect"
            width={120}
            height={14}
            animation="wave"
          />
        );
      })}
    </MUIBreadcrumbs>
  ) : null;
};
